module.exports = __webpack_public_path__ + "img/rxtx-homepage-en.17aacc2d.jpg";